/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ProductDashboardDto = {
    id: string;
    order: number;
    name: string;
    sponsorCode: string;
    productId: string;
    status: ProductDashboardDto.status;
    effectiveFrom?: string;
    effectiveTo?: string;
    imageMetadataId?: string;
};

export namespace ProductDashboardDto {

    export enum status {
        DRAFT = 'DRAFT',
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
        EXPIRED = 'EXPIRED',
        UPCOMING = 'UPCOMING',
    }


}

